import { Draw } from '@slot-nx/core'
import { Graphics } from '@pixi/react'
import { Container } from '@pixi/react'
import { ColorSource } from 'pixi.js'
import { useCallback } from 'react'

interface DrawBackGroundProps {
  x: number
  y: number
  width: number
  height: number
  backgroundColor?: ColorSource
  border?: {
    color: ColorSource
    width: number
  }
  radius?: number
  name?: string
}

export const DrawBg = (props: DrawBackGroundProps) => {
  const draw = useCallback<Draw>((g) => {
    g.clear()
    let startPosition = 0
    let width = props.width
    let height = props.height

    g.beginFill(props.backgroundColor)

    if (props.border) {
      const border = props.border
      g.lineStyle(border)
      startPosition += border.width / 2
      width -= border.width
      height -= border.width
    }

    if (props.radius) {
      g.drawRoundedRect(startPosition, startPosition, width, height, props.radius)
    }
    else {
      g.drawRect(startPosition, startPosition, width, height)
    }
    g.endFill()
  }, [props.backgroundColor, props.border, props.height, props.radius, props.width])

  return (
    <Container
      eventMode="static"
      name={props.name ? props.name : 'DrawBackGroundContainer'}
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
    >
      <Graphics name="BackGroundGraphic" draw={draw} />
    </Container>
  )
}
